/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

